import {html} from 'lit-html';
import {repeat} from 'lit-html/directives/repeat';
import {classMap} from 'lit-html/directives/class-map';
import {styleMap} from 'lit-html/directives/style-map';
import {ifDefined} from 'lit-html/directives/if-defined';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';
import TemplateRegistry from '../template/template-registry';
import {ThemeCurrency} from '../const';
import {
    optionValueClassMap, optionClassMap, sizeClassMap,
    swatchToggle, buttonStyleMap, buttonColorStyleMap,
    optionName, valueSync, optionValueText, optionValuePriceText
} from '../template/template-util.js';

const personalizeCheckboxSync = (e, option, onChange) => {
    // toggle the checkbox value with single checkbox only
    option.value = option.value === option.values[0].value ? option.values[1].value : option.values[0].value;
    return onChange(option);
}

TemplateRegistry.templates['personalize'] = (option, config, onChange) => {

    // NEW: support to show personalize button as checkbox
    if(option.params.btnCheckbox){
        // we show a single checkbox - but the "no" option is also added to always have a selection saved
        return html`
            ${repeat(option.values || [],  (optionValue,index) => {
                if (index === 0) {
                    return html`
                        <label class="cl-po--checkbox-item ${classMap(optionValueClassMap(option, optionValue))}">
                            <input type="checkbox" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}-${index}" name="${optionName(option)}" .value=${optionValue.value} @change=${(e) => personalizeCheckboxSync(e, option, (option) => option._controller.onChange(e, option, true))}
                                   .checked=${option.value == optionValue.value} ?required=${option.required} form=${ifDefined(config.productFormLink)}>
                            ${unsafeHTML(optionValueText(option, optionValue, ThemeCurrency.moneyFormat))}
                        </label>`;
                } else {
                    return html`<input type="checkbox" style="display:none;" name="${optionName(option)}" id="${option.id}" value=${optionValue.value} .checked=${option.value == optionValue.value}  form=${ifDefined(config.productFormLink)} />`;
                }
            }
        )}
        `;
    } else {
        // default radio single selection (swatchToggle function required to support de-selection with radio)
        return html`
            <div class="cl-po--swatch-container">
                ${repeat(option.values || [],  (optionValue,index) => html`

                    <label class="cl-po--swatch-item ${classMap({ grow: option.params.grow, personalize: (option.value == optionValue.value ? 'none': null ) })}" >
                        <input type="radio" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}-${index}" name="${optionName(option)}" .value=${optionValue.value} @change=${(e) => valueSync(e, option, (option) => option._controller.onChange(e, option) )} 
                               .checked=${option.value == optionValue.value} ?required=${option.required} form=${ifDefined(config.productFormLink)}>
                        <div class="cl-po--swatch cl-po--swatch-button ${classMap(sizeClassMap(option, 'small'))}" style=${styleMap(buttonStyleMap(option,buttonColorStyleMap(option)))} data-tippy-content="${ifDefined(option.params.valuePriceTooltip ? optionValuePriceText(option, optionValue, ThemeCurrency.moneyFormat) : undefined)}" data-tippy-placement="bottom"
                             @click=${(e) => swatchToggle(e, option, optionValue, onChange)}>
                            ${unsafeHTML(optionValueText(option, optionValue, ThemeCurrency.moneyFormat))}
                        </div>
                    </label>
                    ${option.params.items && (index + 1) % option.params.items === 0 ? html`<div class="cl-po--break" data-index=${index}></div>` : null}
                `)}
            </div>
        `
    }
};